export default "{\n    \"suspended\": \"Suspendu\",\n    \"deactivated\": \"Désactivé\"\n}\n"